import moment from 'moment-timezone';
import { isNumber } from 'lodash-es';

export const formatYearDate = (date) => moment(date).format('MM/DD/YYYY');

export const getCurrentYear = () => moment().year();

export const getRangeOfPrevYears = (endYear, year) => {
  const listOfYears = [];

  if (!isNumber(endYear) || (endYear < 0 && endYear > year)) {
    return listOfYears;
  }

  let currentYear = year;

  while (currentYear >= endYear) {
    listOfYears.push(`${currentYear}`);
    currentYear -= 1;
  }

  return listOfYears;
};

export function formatTimestampWithTimezone(timestamp, timeZone, timeZoneCode) {
  if (!timestamp) return '';

  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone,
  };

  const date = new Date(timestamp);

  let formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  formattedDate = formattedDate.replace(' at ', ' ');

  return `${formattedDate} ${timeZoneCode}`;
}
